import firebase from 'firebase/compat/app';
import { firebaseConfigAvisos } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import Swal from 'sweetalert';
import { enviarNotificacaoParaTodos } from './mensagens';

const firebaseAvisos = firebase.initializeApp(firebaseConfigAvisos, 'Avisos Letícia');
const db = firebaseAvisos.firestore();
//const storage = firebase.storage();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');
const logado = localStorage.getItem('logado') ? localStorage.getItem('logado').toLowerCase() : null;

const lerAvisos = async () => {
    
    const avisos = [];
    
    try {

        if (logado) {
            const snapshot = await db.collection(ANO)
                .doc(logado)
                .collection('avisos')
                .orderBy('data', 'desc')
                .limit(10)
                .get();

            await Promise.all( snapshot.docs.map(async (doc) => {
                const uid = doc.id;
                const titulo = doc.data().titulo;
                const mensagem = doc.data().mensagem;
                const data = doc.data().data;
                const html = doc.data().html;
                avisos.push({
                    titulo,
                    mensagem,
                    data,
                    uid,
                    html,
                });
            }));
            
            return avisos;
        }

    } catch (error) {
        throw error;
    }
};



export { lerAvisos };